export default __webpack_public_path__ + "static/media/adyen-logo.8d944ca4.svg";